"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFormToolControlOptionInfoByLanguage = exports.getFormToolControlInfoByLanguage = exports.getTicketTypeInfoByLanguage = exports.getEventInfoByLanguage = void 0;
function getEventInfoByLanguage(eventInfos, languageEnum) {
    if (eventInfos.length == 0) {
        return null;
    }
    const eventInfo = eventInfos.find(ei => ei.languageId == languageEnum);
    if (eventInfo) {
        return eventInfo;
    }
    return eventInfos[0];
}
exports.getEventInfoByLanguage = getEventInfoByLanguage;
function getTicketTypeInfoByLanguage(ticketTypeInfos, languageEnum) {
    if (ticketTypeInfos.length == 0) {
        return null;
    }
    const ticketTypeInfo = ticketTypeInfos.find(tti => tti.languageId == languageEnum);
    if (ticketTypeInfo) {
        return ticketTypeInfo;
    }
    return ticketTypeInfos[0];
}
exports.getTicketTypeInfoByLanguage = getTicketTypeInfoByLanguage;
function getFormToolControlInfoByLanguage(formToolControlInfos, languageEnum) {
    if (formToolControlInfos.length == 0) {
        return null;
    }
    const formToolControlInfo = formToolControlInfos.find(ftci => ftci.languageId == languageEnum);
    if (formToolControlInfo) {
        return formToolControlInfo;
    }
    return formToolControlInfos[0];
}
exports.getFormToolControlInfoByLanguage = getFormToolControlInfoByLanguage;
function getFormToolControlOptionInfoByLanguage(formToolControlOptionInfos, languageEnum) {
    if (formToolControlOptionInfos.length == 0) {
        return null;
    }
    const formToolControlOptionInfo = formToolControlOptionInfos.find(ftcoi => ftcoi.languageId == languageEnum);
    if (formToolControlOptionInfo) {
        return formToolControlOptionInfo;
    }
    return formToolControlOptionInfos[0];
}
exports.getFormToolControlOptionInfoByLanguage = getFormToolControlOptionInfoByLanguage;
